export const SET_SERVICE_CALL_LIST = "SET_SERVICE_CALL_LIST";
export const SET_EQUIPMENT_LIST = "SET_EQUIPMENT_LIST";
export const SET_PROBLEM_LIST = "SET_PROBLEM_LIST";
export const SET_SUB_PROBLEM_LIST = "SET_SUB_PROBLEM_LIST";
